export const siteName = process.env.SITE_NAME;
export const siteUrl = process.env.NEXT_PUBLIC_SITE_URL || process.env.SITE_URL;
export const defaultSiteDescription = process.env.DEFAULT_SITE_DESCRIPTION;
export const defaultSiteImage = process.env.DEFAULT_SITE_IMG;

export function composeTitle(pageTitle) {
  if (pageTitle) {
    return `${pageTitle} | Remote`;
  }

  return siteName;
}

export const composeCurrentUrl = (slug) => `${siteUrl}${slug || ''}`.trim();
